<template>
  <div class="secondary-certification-body">
    <div class="info-suc" v-if="infoSuc === 'success'">
      <div class="top-info">
        <span
          >验证码消息已发送至：<span class="information-tools">{{
            appName
          }}</span></span
        >
      </div>
      <div class="input-box">
        <input
          type="text"
          :class="{ err: errInfo }"
          v-model="code"
          placeholder="请输入验证码"
          @input="getInput()"
        />
        <div v-if="isGetCode" @click="getCode" class="getCode">获取验证码</div>
        <div v-else class="again">{{ time }}s后重发</div>
      </div>
      <div class="err-info" v-show="errInfo">{{ errInfo }}</div>
      <div
        class="login-btn"
        :class="{ active: allowLogin }"
        @click="loginHandler"
      >
        登录
      </div>
    </div>
    <div class="info-err" v-if="infoSuc === 'error'">
      <img :src="errIcon" alt="" />
      <div>验证码发送失败</div>
      <div class="err-details">未找到对应的企业微信用户，请联系管理员处理</div>
    </div>
    <div class="switch-account" v-show="infoSuc !== 'init'">
      <span @click="switchAccount">切换账号</span>
    </div>
  </div>
</template>

<script>
import * as UserManager from '../../SDK/UserManager'
import Cookies from 'js-cookie'
export default {
  name: 'secondaryCertification',
  data () {
    return {
      infoSuc: 'init',
      appName: '企业微信',
      code: '',
      timer: null,
      time: 60,
      isGetCode: true,
      errInfo: '',
      token: '',
      errIcon: require('../../../static/img/code_error.svg')
    }
  },
  created () {
    // 30min 未操作返回登录页
    this.token = Cookies.get('CA-LENOVO-AUTH-TOKEN')
    if (!this.token) {
      this.$router.replace({ path: '/' })
    }
    let refresh = sessionStorage.getItem('refresh')
    var errorMessage = sessionStorage.getItem('errorMsg')
    this.info = JSON.parse(sessionStorage.getItem('info'))
    this.errInfo = ''
    if (this.info && this.info.result) {
      this.appName = this.info.app_name
      this.infoSuc = 'success'
      if (refresh) {
        this.isGetCode = false
        this.timeFun()
        sessionStorage.removeItem('refresh')
      }
    } else if (this.info && this.info.state === 404) {
      this.infoSuc = 'error'
    } else if (this.info && this.info.state === 401) {
      this.infoSuc = 'success'
      if (this.info.code === 'ip is forbidden') {
        this.errInfo = this.info && this.info.message
        this.code = ''
      } else {
        let seconds = 5
        let expires = new Date(new Date() * 1 + seconds * 1000)
        Cookies.set('err_message', this.info.message, { expires: expires })
        this.$router.replace({ path: '/' })
      }
      console.log(this.info.message, 'this.info.message')
    } else {
      this.infoSuc = 'success'
      if (!errorMessage) {
        this.errInfo = ''
      } else {
        this.errInfo = this.info && this.info.message
        sessionStorage.removeItem('errorMsg')
      }
    }
  },
  computed: {
    allowLogin () {
      return this.code !== ''
    }
  },
  methods: {
    getCode () {
      let postData = {
        user_slug: sessionStorage.getItem('user_slug'),
        lenovo_token: Cookies.get('CA-LENOVO-AUTH-TOKEN')
      }
      UserManager.getCode(postData)
        .then(response => {
          if (response.result) {
            this.errInfo = ''
            this.appName = response.app_name
            this.infoSuc = 'success'
            this.isGetCode = false
            this.timeFun()
          }
        }, err => {
          if (err.state === 404) {
            this.infoSuc = 'error'
          } else if (err.state === 401) {
            this.infoSuc = 'success'
            if (err.code === 'ip is forbidden') {
              this.errInfo = err.message
              this.code = ''
            } else {
              let seconds = 5
              let expires = new Date(new Date() * 1 + seconds * 1000)
              Cookies.set('err_message', err.message, { expires: expires })
              this.$router.replace({ path: '/' })
            }
          } else {
            this.infoSuc = 'success'
            this.errInfo = err.message
            this.code = ''
          }
        })
    },
    getInput () {
      if (this.code) {
        this.errInfo = ''
      }
    },
    loginHandler () {
      if (!this.allowLogin) {
        return false
      }
      this.errInfo = ''
      let postData = {
        user_slug: sessionStorage.getItem('user_slug'),
        lenovo_token: Cookies.get('CA-LENOVO-AUTH-TOKEN'),
        captcha: this.code
      }
      UserManager.verifyCode(postData)
        .then(response => {
          sessionStorage.userInfo = JSON.stringify(response)
          this.$store.commit('login', response)
          this.$router.replace({ path: '/' })
          location.reload()
        }, err => {
          if (err.state === 401) {
            if (err.code === 'ip is forbidden') {
              this.errInfo = err.message
              this.code = ''
            } else {
              let seconds = 5
              let expires = new Date(new Date() * 1 + seconds * 1000)
              Cookies.set('err_message', err.message, { expires: expires })
              this.$router.replace({ path: '/' })
            }
          } else {
            this.errInfo = err.message
            this.code = ''
          }
        })
    },
    timeFun () {
      this.timer = setInterval(() => {
        if (this.time === 0) {
          this.time = 60
          this.isGetCode = true
          clearInterval(this.timer)
        } else {
          this.isGetCode = false
          this.time--
        }
      }, 1000)
    },
    switchAccount () {
      this.$router.replace({ path: '/' })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../common/stylus/global.styl';

.secondary-certification-body {
  .info-suc {
    padding-top: 3.093333rem;
    .top-info {
      font-size: 0.426667rem;
      margin-left: 0.6rem;
      .information-tools {
        font-weight: 700;
      }
    }

    .input-box {
      padding: 2.666667rem 0 0;
      width: 9.2rem;
      margin: auto;
      display: flex;
      justify-content: space-around;

      input {
        height: 1.146667rem;
        width: 5.733333rem;
        border: 0.013333rem solid #C1C7CD;
        background: transparent;
        margin-right: 0.4rem;
        padding: 0 0.4rem;
        color: #929CA9;
        border-radius: 0.08rem;
        font-size: .426667rem
      }
      .getCode {
        font-size: .426667rem
        color: #1b2733
      }
      .again {
        font-size: .426667rem
      }
      .err {
        border-color: #FD4147;
      }

      div {
        width: 3.066667rem;
        border: 0.013333rem solid #C1C7CD;
        font-size: 0.373333rem;
        text-align: center;
        line-height: 1.146667rem;
        border-radius: 0.08rem;
        color: #C1C7CD
      }
    }

    .err-info {
      min-height: 0.48rem;
      line-height: 0.48rem;
      margin: 0.213333rem auto 0.4rem;
      color: #FF3D3C;
      font-size: 0.426667rem;
      width: 9.2rem;
    }

    .login-btn {
      width: 9.2rem;
      height: 1.173333rem;
      line-height: 1.173333rem;
      text-align: center;
      color: #fff;
      background: #85B2FD;
      font-size: 0.426667rem;
      margin: 0.4rem auto 0;

      &.active {
        background: #0A64FA;
      }
    }
  }

  .info-err {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3.12rem 0 0;
    margin-bottom: 4.346667rem;

    img {
      width: 1.226667rem;
      margin-bottom: 0.533333rem;
    }

    div {
      color: #282E3D;
      font-size: 0.426667rem;
    }

    .err-details {
      color: #929CA9;
      font-size: 0.373333rem;
      margin-top: 0.186667rem;
    }
  }

  .switch-account {
    margin-top: 0.533333rem;
    text-align: center;

    span {
      font-size: 0.426667rem;
      color: #282E3D
    }
  }
}
</style>



// WEBPACK FOOTER //
// secondary-certification.vue?6778488c